// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_gQ","advertCardFooter__row":"c-a_gR","advertCardFooter__name":"c-a_gS","advertCardFooter__price":"c-a_gT","advertCardFooter__age":"c-a_gU"};